<div class="row top-margin-15 nova-font-style manage-banking-info">
  <div class="col s12 m12 offset-l1 l10 offset-l1 xl8 offset-xl2">
    <h2>Terminate Employee</h2>
    <div class="top-margin-15">
      <!-- EMPLOYEE DETAILS -->
      <p class="headingrow"><span class="bold headingtext">Employee Details</span></p>
      <div class="row top-margin-15">
        <div class="col s12 m4 l3 xl3">
          <span class="bold">Employee SSN:</span>
        </div>
        <div class="col s8 m5 l4 xl4">
          <kendo-maskedtextbox id="ssn" [mask]="ssnMask" (valueChange)="onSsnChange($event)" [value]="value">
          </kendo-maskedtextbox>
          <div class="top-margin-1">
            <span class="tooltip-validation" *ngIf="validSSNMsg">
              Valid SSN is required
            </span>
          </div>
        </div>
        <div class="col s4 m2 l2 xl2">
          <button type="submit" id="search-btn" class="btn background-red" (click)="serachEmployeeSsn()"
            [disabled]="searchBtnEnable">
            <span class="k-icon k-i-search"></span>
          </button>
        </div>
      </div>
      <div class="text-red" *ngIf="empNotFound">
        <span class="k-icon k-i-warning"></span>{{noContectMsg}}
      </div>
      <div *ngIf="isEmpDetailValid">
        <div class="row">
          <div class="col s12 m4 l3 xl3">
            <span class="bold">Employee Name:</span>
          </div>
          <div class="col s8 m5 l4 xl4" id="employee-name">{{employeeName}}</div>
        </div>
        <!-- EMPLOYEMENT INFO -->
        <div class="top-margin-15">
          <p class="headingrow"><span class="bold headingtext">Employment Information</span></p>
        </div>
        <p class="bottom-margin-10" id="grid-msg" [innerHTML]="config.EmployementMsg"></p>
        <p class="bottom-margin-10" id="grid-msg" [innerHTML]="config.EmployeeTermMsg"></p>
        <div>
          <kendo-grid [kendoGridBinding]="gridData" [sortable]="true" id="terminate-employee-grid">
            <!-- MOBILE VIEW -->
            <kendo-grid-column media="(max-width: 900.98px)" title="Details" [width]="120">
              <ng-template kendoGridCellTemplate let-dataItem>
                <dl>
                  <dd>
                    <div class="align-left">
                      <span class="bold">System/Plan:</span>
                      {{ dataItem.systemPlan }}
                    </div>
                  </dd>
                  <dd>
                    <div class="align-left">
                      <span class="bold">Location:</span>
                      {{ dataItem.location }}
                    </div>
                  </dd>
                  <dd>
                    <div class="align-left">
                      <span class="bold">Last Reported PPED:</span>
                      {{ dataItem.LastPayrollDate | date: 'MM/dd/yyyy' }}
                    </div>
                  </dd>
                </dl>
              </ng-template>
            </kendo-grid-column>
            <!-- SYS/PLAN -->
            <kendo-grid-column field="systemPlan" media="(min-width: 901px)" title="System/Plan" [width]="200"
              [headerClass]="{'align-id': true}"></kendo-grid-column>
            <!-- LOCATION -->
            <kendo-grid-column field="location" media="(min-width: 901px)" title="Location" [width]="90"
              [headerClass]="{'align-id': true}"></kendo-grid-column>
            <!-- LAST REPORTED PPED -->
            <kendo-grid-column field="lastPayrollDate" media="(min-width: 901px)" title="Last Reported PPED"
              [width]="100" [headerClass]="{'align-date': true}">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="align-date">
                  {{dataItem.lastPayrollDate | date: 'MM/dd/yyyy'}}
                </div>
              </ng-template>
            </kendo-grid-column>
            <!-- HAS MEMBER TERMINATED EMPLOYEE -->
            <kendo-grid-column media="(min-width: 901px)" field="isTerminated" title="Has Member Terminated Employment?"
              [headerStyle]="{'text-align': 'center'}" [width]="150" *ngIf="operators.Edit">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <div class="align-center">
                  <kendo-switch [checked]="dataItem.isTerminated" onLabel="Yes" offLabel="No"
                  id="member{{dataItem.employmentId}}" (valueChange)="onSwitchChange($event, dataItem)"></kendo-switch>
                </div>
              </ng-template>
            </kendo-grid-column>
            <!-- RESIGNATION/TERMINATION DATE -->
            <kendo-grid-column field="terminateDt" media="(min-width: 901px)" title="Resignation/Termination Date"
              [width]="200" [headerClass]="{'align-date': true}" *ngIf="operators.Edit">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="align-date">
                  <kendo-datepicker [(ngModel)]="dataItem.terminateDt" placeholder="MM/DD/YYYY" [min]="dataItem.min" [max]="dataItem.max"
                    name="terDate{{dataItem.employmentId}}" id="terDate{{dataItem.employmentId}}" #terminateDt="ngModel"
                    (valueChange)="onDateChange(dataItem, $event)" [disabled]="!dataItem.isTerminated">
                  </kendo-datepicker>
                </div>
                <div class="top-margin-1 align-date" *ngIf="dataItem.termDateNotValid">
                  <span class="tooltip-validation left-margin-0 page-bottom inherit-position">
                    {{config.DateError}}
                  </span>
                </div>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>

        <!-- ACTION BTN -->
        <div class="row bottom-margin-0" id="action-btn">
          <div class="col s12 m12 l8 offset-l2 xl8 xl8 offset-xl2 padding-0">
            <div class="margin-20 align-center" id="action-btn">
              <button kendoButton class="background-red border-red padding-10 margin-10 text-white" id="cancel-Btn"
                (click)="cancelChanges()">Cancel</button>
              <button kendoButton class="background-red border-red padding-10 margin-10 left-margin-10 text-white"
                id="submit-Btn" [hidden]="!operators.Edit" [disabled]="!isSubmitBtnDisable"
                (click)="submitTerEmpDialog = true">Submit</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>
<!-- SUBMIT EMPLOYEE DETAIL DIALOG -->
<kendo-dialog title="Terminate Employee" class="app-dialog" *ngIf="submitTerEmpDialog" [minWidth]="250"
  id="adj-submit-dialog" (close)="closeDialog()">
  <p>Do you want to terminate <strong class="bold">{{employeeName}}</strong>?</p>
  <div *ngIf="displayload">
    <div class="stroke-separator-margin-5"></div>
    <span class="k-i-loading k-icon col-md-offset-5 dialog-inner-loading"></span>
    <span class="dotLoading">Submitting</span>
  </div>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" [disabled]="displayload" (click)="closeDialog()" primary="true">Cancel</button>
    <button kendoButton class="k-button" [disabled]="displayload" (click)="terminateEmployee()"
      primary="true">Submit</button>
  </kendo-dialog-actions>
</kendo-dialog>
